module.exports = __webpack_public_path__ + "static/media/conceptActive.46ae8748.svg";